module.exports = __webpack_public_path__ + "static/media/organic-keywords-sample.37a3f137.png";